const reportsKey = '/report';

export const reports = () => {
  return reportsKey;
};
